import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { PulsaraConstants } from '../store/pulsara.constants'
import { PATIENT_MATCH_SUB_STEP_IDS, STEP_IDS } from '../constants'
import { cloneDeep } from 'lodash'
import { initialPulsaraState } from '../store/pulsara.reducers'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getPulsaraSelector } from '../selectors'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { IPulsaraState } from '../store/pulsara.types'
import { getPreviousNavigation } from '../utils/pulsaraNavigation.util'
import { setPulsaraState } from '../store/pulsara.actions'
import { getPcrIdSelector } from '../../home/selectors/getPcrId.selector'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'

function* handleResetsOnBack() {
  try {
    const pulsaraState: IPulsaraState = yield select(getPulsaraSelector)
    const { FORCE_PT_SEARCH } = yield select(getServiceConfigSelector)
    const { currentStep, currentSubStep, pulsaraDetails } = pulsaraState
    const updatedPulsaraState = cloneDeep(pulsaraState)
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrID: string = yield select(getPcrIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const hasVitalsOrLabs = pulsaraDetails?.vitals?.length > 0 || pulsaraDetails?.labs?.length > 0
    const hasAttachments = (pulsaraDetails?.attachmentList?.length ?? 0) > 0
    const importData = { hasVitalsOrLabs, hasAttachments }

    const isGoingBackFromPatientConflict =
      currentStep === STEP_IDS.PATIENT_MATCH && currentSubStep === PATIENT_MATCH_SUB_STEP_IDS.PATIENT_CONFLICT

    const hasImportedCadData = !!pcrDoc.cadImport?.importedCadData
    const alreadyHasPatient = !!(pcrDoc?.ptid || pcrDoc?.patient?.patientInformation?.newPatient || hasImportedCadData)

    const navigation = getPreviousNavigation(
      currentStep,
      currentSubStep,
      FORCE_PT_SEARCH,
      alreadyHasPatient,
      importData
    )
    if (!navigation) {
      return
    }

    const isGoingBackToPulsaraSearch = navigation.step === STEP_IDS.PULSARA_SEARCH

    if (isGoingBackFromPatientConflict) {
      updatedPulsaraState.emsChartsData = cloneDeep(initialPulsaraState.emsChartsData)
      updatedPulsaraState.patientSelections = {}
      updatedPulsaraState.importSelections = cloneDeep(initialPulsaraState.importSelections)
      updatedPulsaraState.selectedAttachment = null
    }

    if (isGoingBackToPulsaraSearch) {
      updatedPulsaraState.selectedPulsaraId = null
      updatedPulsaraState.pulsaraDetails = {
        caseType: '',
        createdAt: '',
        patient: initialPulsaraState.pulsaraDetails.patient,
        situation: initialPulsaraState.pulsaraDetails.situation,
        vitals: [],
        labs: [],
        attachmentList: [],
        attachments: [],
      }
    }

    updatedPulsaraState.currentStep = navigation.step
    updatedPulsaraState.currentSubStep = navigation.subStep
    yield put(setPulsaraState(updatedPulsaraState))
  } catch (e) {
    yield put(throwPcrException(`handleResetsOnBack() error: ${e}`))
  }
}

export function* handleResetsOnBackSaga() {
  yield takeLatest(PulsaraConstants.HANDLE_RESETS_ON_BACK, performWithMutexHOG, handleResetsOnBack)
}
